import {
  ElectricityIcon,
  HeatIcon,
  WaterIcon,
} from '@components/icons/UtilityTypeIcons';
import { UtilityTypeEnum } from 'enums/UtilityTypeEnum';
import { type ReactNode, type SVGProps } from 'react';

export const getUtilityIcon = (
  utility: UtilityTypeEnum,
  fill?: string,
  props?: SVGProps<SVGSVGElement>
): ReactNode => {
  switch (utility?.toUpperCase()) {
    case UtilityTypeEnum.ELECTRICITY:
      return <ElectricityIcon fill={fill} {...props} />;
    case UtilityTypeEnum.WATER:
      return <WaterIcon fill={fill} {...props} />;
    case UtilityTypeEnum.GAS:
      return <HeatIcon fill={fill} {...props} />;
    case UtilityTypeEnum.FUEL_OIL:
      return <HeatIcon fill={fill} {...props} />;
    case UtilityTypeEnum.THERMAL_ENERGY:
      return <HeatIcon fill={fill} {...props} />;
    case UtilityTypeEnum.STEAM:
      return <HeatIcon fill={fill} {...props} />;
    case UtilityTypeEnum.CONDENSATE:
      return <HeatIcon fill={fill} {...props} />;
    default:
      return <></>;
  }
};

export const getUtilityTypeReadableName = (
  utility: UtilityTypeEnum
): string | null => {
  switch (utility) {
    case UtilityTypeEnum.ELECTRICITY:
      return 'Electricity';
    case UtilityTypeEnum.WATER:
      return 'Water';
    case UtilityTypeEnum.GAS:
      return 'Gas';
    case UtilityTypeEnum.FUEL_OIL:
      return 'Fuel oil';
    case UtilityTypeEnum.THERMAL_ENERGY:
      return 'Thermal energy';
    case UtilityTypeEnum.STEAM:
      return 'Steam';
    case UtilityTypeEnum.CONDENSATE:
      return 'Condensate';
    case UtilityTypeEnum.CARBON_DIOXIDE:
      return 'Carbon dioxide';
    case UtilityTypeEnum.AIR_PRESSURE:
      return 'Air pressure';
    case UtilityTypeEnum.TEMPERATURE:
      return 'Temperature';
    case UtilityTypeEnum.HUMIDITY:
      return 'Humidity';
    default:
      return null;
  }
};

export const getUtilityTypeUnit = (utility: UtilityTypeEnum): string => {
  switch (utility) {
    case UtilityTypeEnum.ELECTRICITY:
      return 'kWh';
    case UtilityTypeEnum.WATER:
      return '㎥';
    case UtilityTypeEnum.GAS:
      return 'kWh';
    case UtilityTypeEnum.FUEL_OIL:
      return 'kWh';
    case UtilityTypeEnum.THERMAL_ENERGY:
      return 'kWh';
    case UtilityTypeEnum.CARBON_DIOXIDE:
      return 'ppm';
    case UtilityTypeEnum.AIR_PRESSURE:
      return 'hPa';
    case UtilityTypeEnum.TEMPERATURE:
      return '°C';
    case UtilityTypeEnum.HUMIDITY:
      return '%';
    default:
      return 'kWh';
  }
};
